import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const IsChromeGuard = () => {
  const router: Router = inject(Router);

  const isChrome: boolean = navigator.userAgent.indexOf('Chrome') !== -1;
  if (!isChrome) {
    return router.navigate([ 'notChrome' ]);
  }
  return isChrome;
}
